/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramStatusBlockTextMngDto } from './programStatusBlockTextMngDto';


export interface ProgramStatusBlockMngDto { 
    /**
     * The type of the status block. Identifies the structure of \"content\" property.
     */
    statusBlockType: ProgramStatusBlockMngDto.StatusBlockTypeEnum;
    /**
     * The content of the status block. The structure can vary, it can be identified via \"statusBlockType\" property.
     */
    content: ProgramStatusBlockTextMngDto;
}
export namespace ProgramStatusBlockMngDto {
    export type StatusBlockTypeEnum = 'text';
    export const StatusBlockTypeEnum = {
        Text: 'text' as StatusBlockTypeEnum
    };
}


